/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const common = {
  common: {
    cancel: 'Cancel',
    delete: 'Delete',
    remove: 'Remove',
    edit: 'Edit',
    restore: 'Restore',
    back: 'Back',
    submit: 'Submit',
    continue: 'Continue',
    save: 'Save',
    done: 'Done',
    home: 'Home',
    noData: 'No data available.',
    confirm: 'Confirm',
    more: 'More',
    close: 'Close',
    loading: 'Loading',
    menu: 'Menu',
    reset: 'Reset',
    search: 'Search',
    add: 'Add',
    breadcrumbs: 'Breadcrumbs',
    selectFile: 'Select a file',
    clear: 'Clear',
    loaded: 'Loaded',
    results: 'Results',
    of: 'of',
  },
  pageMetaResolver: {
    category: {
      title: '{{count}} result for "{{query}}"',
      title_other: '{{count}} results for "{{query}}"',
    },
    checkout: {
      title: 'Checkout',
    },
    search: {
      title: '{{count}} result for "{{query}}"',
      title_other: '{{count}} results for "{{query}}"',
      findProductTitle: '{{count}} result for coupon "{{coupon}}"',
      findProductTitle_other: '{{count}} results for coupon "{{coupon}}"',
      default_title: 'All Products',
    },
    product: {
      description: '{{{description}}}',
      heading: '{{{heading}}}',
      title: '{{{title}}}',
    },
  },
  spinner: {
    loading: 'Loading...',
  },
  navigation: {
    categoryNavLabel: 'Category menu',
    footerNavLabel: 'Footer links',
    navigateTo: 'Navigate to {{{nav}}}',
    scrollToTop: 'Scroll back to the top of the page',
  },
  searchBox: {
    placeholder: 'Enter product name or code',
    productSearch: 'Searching for a product',
    ariaLabelInput: 'Input area',
    ariaLabelSuggestions: 'Typing suggestions',
    ariaLabelProducts: 'Product results',
    initialDescription:
      'When autocomplete results are available, use up and down arrows to review and Enter to select. Touch device users can explore by touch or swipe gestures.',
suggestionsResult: '{{count}} suggestion available',
suggestionsResult_other: '{{count}} suggestions available',
productsResult: '{{count}} product available.',
productsResult_other: '{{count}} products available.',
resetLabel: 'Reset search',
help: {
  insufficientChars: 'Please type more characters',
  noMatch: 'No results found',
  exactMatch: '{{term}}',
  empty: 'Ask us anything',
},
},
sorting: {
date: 'Date',
orderNumber: 'Order Number',
rma: 'Return Number',
replenishmentNumber: 'Replenishment Number',
nextOrderData: 'Next Order Data',
pageViewUpdated: 'The page view has been updated with the selected options.',
},
httpHandlers: {
badRequest: {
  bad_credentials: 'Invalid credentials. Please log in again.',
  user_is_disabled: 'User is disabled. Please contact support.',
},
badGateway: 'A server error occurred. Please try again later.',
badRequestPleaseLoginAgain: '{{errorMessage}}. Please log in again.',
badRequestOldPasswordIncorrect: 'The old password is incorrect.',
badRequestGuestDuplicateEmail:
  '{{errorMessage}} The email already exists. Use a different email to check out as a guest.',
conflict: 'Already exists.',
forbidden:
  'You are not authorized to perform this action. Contact the administrator if you believe this is an error.',
gatewayTimeout: 'The server did not respond, please try again later.',
internalServerError:
  'An internal server error occurred. Please try again later.',
sessionExpired: 'Your session has expired. Please log in again.',
unknownError: 'An unknown error occurred.',
unauthorized: {
  common: 'An unknown authorization error occurred.',
  invalid_client: 'Incorrect client credentials.',
},
validationErrors: {
  missing: {
    card_cardType: 'The selected credit card is not supported. Please select another.',
    card_accountNumber: 'The entered credit card number is invalid.',
    card_cvNumber: 'The entered security code is invalid.',
    card_expirationMonth: 'The entered credit card expiration date is invalid.',
    card_expirationYear: 'The entered credit card expiration date is invalid.',
    billTo_firstName: 'The entered first name is invalid.',
    billTo_lastName: 'The entered last name is invalid.',
    billTo_street1: 'The entered address is invalid.',
    billTo_street2: 'The entered address is invalid.',
    billTo_city: 'The entered city is invalid for this credit card.',
    billTo_state: 'The entered state/province is invalid for this credit card.',
    billTo_country: 'The entered country/region is invalid for this credit card.',
    billTo_postalCode: 'The entered zip/postal code is invalid for this credit card.',
    country: {
      isocode: 'Country/region is missing.',
    },
  },
  invalid: {
    card_expirationMonth: 'The entered credit card expiration date is invalid.',
    firstName: 'The entered first name is invalid.',
    lastName: 'The entered last name is invalid.',
    password: 'The entered password is invalid.',
    uid: 'The entered UID is invalid.',
    code: 'The entered code is invalid.',
    email: 'The entered email is invalid.',
  },
},
cartNotFound: 'Cart not found.',
invalidCodeProvided: 'An invalid code was provided.',
voucherExceeded: 'This voucher has exceeded its usage limit.',
unknownIdentifier: 'Item not found.',
otherCartErrors: 'Errors occurred in the cart.',
},
miniCart: {
item: '{{count}} item currently in your cart',
item_other: '{{count}} items currently in your cart',
total: '{{total}}',
count: '{{count}}',
entries: 'Items',
},
skipLink: {
skipTo: 'Skip to',
labels: {
  header: 'Header',
  main: 'Main content',
  footer: 'Footer',
  productFacets: 'Product facets',
  productList: 'Product list',
},
},
carousel: {
previousSlide: 'Previous slide',
nextSlide: 'Next slide',
slideNumber: 'Slide {{{currentSlideNumber}}}',
carouselForProduct: 'Carousel, Images for {{{product}}}',
},
formErrors: {
globalMessage: 'The form you are trying to submit contains errors.',
required: 'This field is required.',
cxInvalidEmail: 'This is not a valid email format.',
cxInvalidPassword: 'This is not a valid password format.',
cxPasswordsMustMatch: 'The password fields must match.',
cxEmailsMustMatch: 'The email fields must match.',
cxStarRatingEmpty: 'The rating field is required.',
cxNoSelectedItemToCancel: 'Please select at least one item.',
cxNegativeAmount: 'The amount must be equal to or greater than zero.',
cxContainsSpecialCharacters: 'The field cannot contain special characters.',
date: {
  required: 'This field is required.',
  min: 'The date cannot be earlier than {{{min}}}.',
  max: 'The date cannot be later than {{{max}}}.',
  pattern: 'Use the yyyy-mm-dd date format.',
  invalid: 'Use a valid date.',
},
file: {
  required: 'A file is required.',
  empty: 'The file must not be empty.',
  invalidExtension: 'The file extension is invalid.',
  tooLarge: 'The file size must not exceed {{maxSize}} MB.',
  tooManyEntries: 'The number of items exceeds {{maxEntries}}.',
  notParsable: 'The file cannot be verified.',
  fileNotAllowed: 'This file type is not allowed.',
},
},
errorHandlers: {
scriptFailedToLoad: 'The script could not be loaded.',
refreshThePage: 'Please refresh the page.',
},
assistiveMessage: {
actionCancelled: 'Action cancelled, nothing changed.',
},
passwordVisibility: {
showPassword: 'Show password',
hidePassword: 'Hide password',
},
generalErrors: {
pageFailure: 'The page could not be loaded. Please try again later.',
},
chatMessaging: {
charactersLeft: 'Characters left: {{count}}',
addNewMessage: 'Add new message',
send: 'Send',
uploadFile: 'Upload file',
informationLabel: '{{{author}}} {{{text}} on {{{date}}}',
messages: 'Messages',
addMessagePlaceHolder: 'Start typing...',
characterLimitAlert: 'Character limit reached.',
},
};
